export const CONTROL_MAPPED_FILTER_UNSELECTED = '';
export const CONTROL_MAPPED_FILTER_YES = 'true';
export const CONTROL_MAPPED_FILTER_NO = 'false';

export const PROCESS_MAPPED_FILTER_UNSELECTED = '';
export const PROCESS_MAPPED_FILTER_NO = 'false';

export const CONTROL_MAPPED_FILTER_OPTIONS = [
  { label: 'Yes', value: CONTROL_MAPPED_FILTER_YES },
  { label: 'No', value: CONTROL_MAPPED_FILTER_NO },
];

export const SOURCE_FILTER_OPTIONS = [
  { label: 'All Sources', value: 'all' },
  { label: 'Manual', value: 'manual' },
  { label: 'AI Assisted', value: 'ai_assisted' },
  { label: 'Batch Import', value: 'batch_import' },
];

export const RISK_LEVEL_FILTER_OPTIONS = [
  { label: 'All Levels', value: 'all' },
  { label: 'High', value: 'High' },
  { label: 'Medium', value: 'Medium' },
  { label: 'Low', value: 'Low' },
];

export function buildRiskCategoryFilterOptions(uniqueCategories) {
  return [
    { label: 'All Categories', value: 'all' },
    ...uniqueCategories.map((cat) => ({ label: cat, value: cat })),
  ];
}

